import { i18n } from '@/lang/i18n';
import { environmentService, postRequestHandler, getRequestHandler } from '@/utils/services';
import { compressToUTF16 as compress, decompressFromUTF16 as decompress }  from 'lz-string';
import { format, differenceInDays, setDate } from 'date-fns';
import axios from 'axios';

const DefaultState = ()=>{
  return {
    apiUrlRatePlan:null,
    apiUrlRT: null,
    rateUpdateData: {
      title:'',
      showroomtype: null,
      showrateplan: null,
      showdate: null,
      currency: null,
      mealplan: null,
      markup: null,
      allow_child: null,
      discount_rate: null,
      minstay: null,
      maxstay: null,
      cancellation: null,
      advance_purchase: null,
      record: [],
    },
    data: [],
    currencies:[],
    calendar: [],
    rateSearch: {},
    selectedHotel: null,
    sortedRates: null,
    operators: null,
    ratesPlan: '',
    roomTypes: '',
    isLoading: false,
    isRatesReady: false,
    ratesData: [],
    openCreateRateQuickview: false,
    openUpdateRateQuickview: false,
    reloadData: false,
    message: 'TO START SELECT A HOTEL'
  };
},
      state = DefaultState(),
      getters = {
        operators: state => state.operators,
        data: state => state.data,
        isRatesReady: state => state.isRatesReady,
        message: state => state.message,
        selectedHotel: state => state.selectedHotel,
        ratesPlan: state => state.ratesPlan,
        currencies: state => state.currencies,
        roomTypes: state => state.roomTypes,
        reloadData: state => state.reloadData,
        isLoading: state => state.isLoading,
        ratesData: state => state.ratesData,
        rateSearch: sate => state.rateSearch,
        calendar: state => state.calendar,
        rateUpdateData: state => state.rateUpdateData,
        openCreateRateQuickview: state => state.openCreateRateQuickview,
        openUpdateRateQuickview: state => state.openUpdateRateQuickview

      },
      mutations = {
        setApiUrls(state){
          state.apiUrlRatePlan = environmentService.apiUrlRatePlan;
          state.apiUrlRT = environmentService.apiUrlHotel;
        },
        setCurrencies(state, payload){
          state.currencies = payload;
        },
        setOperators(state, payload){
          state.operators = payload.map(operator=>operator.id);
        },
        setSelectedHotel(state, payload){
          state.selectedHotel = payload;
        },
        setRatesPlan(state, payload){
          state.ratesPlan = payload;
        },
        setRoomTypes(state, payload){
          state.roomTypes = payload;
        },
        setLoadingState(state, payload){
          state.isLoading = payload;
        },
        setRatesData(state, payload){
          state.ratesData = payload;
          state.ratesData.check = state.ratesPlan;
          state.ratesData.statusrateplan = Array.isArray(state.ratesData.check)
        },
        setRatesReady(state, payload) {
          state.isRatesReady = payload;
        },
        setReloadData(state, payload){
          state.reloadData = payload;
        },
        setMessage(state, payload) {
          state.message = payload;
        },
        setRateSearch(state, payload){
          Object.assign(state.rateSearch, payload);
        },
        setCreateRateQuickview(state, payload) {
          state.openCreateRateQuickview = payload;
        },
        setUpdateRateQuickview(state, payload) {
          state.openUpdateRateQuickview = payload;
        },
        setUpdateRateDataQuickview(state, payload) {
          state.openUpdateRateQuickview = false;
          state.rateUpdateData.iva = payload.roomtype.hotel.town.iva;
          state.rateUpdateData.showrateplan = payload.rateplan.rateplan;
          state.rateUpdateData.showroomtype = payload.roomtype.name;
          state.rateUpdateData.record = _.filter(payload.rateplan.rates, function(o, index) {
            return o.date == payload.item.date;
          });
          if (payload.action == 'create') {
            state.rateUpdateData.key='newRate';
            state.rateUpdateData.title = 'Create';
            state.rateUpdateData.showdate = payload.item.date;
            state.rateUpdateData.currency = payload.item.currency;
          } else if (payload.action == 'update') {
            state.rateUpdateData.title = 'Update';
            state.rateUpdateData.key = payload.item.id;
            state.rateUpdateData.showdate = payload.item.date;
            state.rateUpdateData.currency = payload.rateplan.currency;
            state.rateUpdateData.mealplan = payload.rateplan.mealplan;
            state.rateUpdateData.markup = payload.rateplan.markup;
            state.rateUpdateData.allow_child = payload.rateplan.allow_child;
            state.rateUpdateData.discount_rate = payload.rateplan.discount_rate;
            // Show the most restrictive stay rule between the rateplan and the
            // channel restriction stored on this date's inventory row.
            const inventoryLos = state.rateUpdateData.record[0] || {};
            state.rateUpdateData.minstay = Math.max(
              Number(payload.rateplan.minstay) || 0,
              Number(inventoryLos.min_stay) || 0
            );
            const maxStays = [payload.rateplan.maxstay, inventoryLos.max_stay]
              .map(value => Number(value) || 0)
              .filter(value => value > 0);
            state.rateUpdateData.maxstay = maxStays.length ? Math.min.apply(null, maxStays) : 0;
            state.rateUpdateData.cancellation = payload.rateplan.cancellation;
            state.rateUpdateData.advance_purchase = payload.rateplan.advance_purchase;
          } else {
            state.rateUpdateData = DefaultState().rateUpdateData;
          }
          state.openCreateRateQuickview = false;
          state.openUpdateRateQuickview = true;
        },
        setSortedRates(state, payload) {
          state.sortedRates = payload;
        },
        setCalendar(state, payload) {
          if (payload=='RESET') {
            state.calendar = [];
          } else {
            state.calendar.push(payload);
          }
        },
        rateRecordUpdate(state, payload) {
          let room_index = state.ratesData.data.findIndex(room => room.id == payload[0].roomtype_id);
          // Save the rateplan from very first element, all registers have the same hence the 0 position element.
          let rateplan_index = state.ratesData.data[room_index].ratePlans.findIndex(rate => rate.rateplan_id == payload[0].rateplan_id);
          let current_rates = Object.values(state.ratesData.data[room_index].ratePlans[rateplan_index].rates);
          const edited_indexes = payload.map(rate =>{
            return current_rates.findIndex(crate => crate.id === rate.id);
          });
          for (let i=0; i<edited_indexes.length;i++){
            let edit = state.ratesData.data[room_index].ratePlans[rateplan_index].rates[edited_indexes[i]];
            edit.base_value = payload[i].base_value;
            edit.sale_value = payload[i].sale_value;
            edit.sale_value_with_tax = payload[i].sale_value_with_tax;
          }
        },
        RESET_RATES_MODULE(state) {
          Object.assign(state, DefaultState());
        }
      },
      actions = {
        setApiUrls({ commit }){
          commit('setApiUrls');
        },
        setRatesReady({ commit }, payload) {
          commit('setRatesReady', payload);
        },
        async getCurrencies({ commit, state, rootState }){
          if (!state.apiUrlRatePlan) {
            commit('setApiUrls');
          }
          const results =  await getRequestHandler(`${state.apiUrlRatePlan}/currencies`, { headers: rootState.auth.headers});
          commit('setCurrencies', results);
        },
        setMessage({ commit }, payload) {
          commit('setMessage', payload);
        },
        setCreateRateQuickview({ commit }, payload) {
          commit('setCreateRateQuickview', payload);
        },
        setUpdateRateQuickview({ commit }, payload) {
          commit('setUpdateRateQuickview', payload);
        },
        setUpdateRateDataQuickview({ commit }, payload) {
          commit('setUpdateRateDataQuickview', payload);
        },
        rateRecordUpdate({ commit }, payload){
          commit('rateRecordUpdate', payload);
        },
        setReloadData({ commit }, payload) {
          commit('setReloadData', payload);
        },
        async createRate({ commit, dispatch, rootState}, payload) {
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlRatePlan}/rates/create`, payload, {headers: rootState.auth.headers});
          if (result.data.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rates.rates'), type:'success', text:i18n.t('lang.store.rates.createSuccess')}, {root:true});
            commit('setReloadData', true);
          } else {
            let errors;
            result.data.errors.forEach(element => {
              errors = errors + " " + element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rates.rates'), type:'error', text:errors}, {root: true});
          }
        },
        async editRate({ commit, dispatch, rootState }, payload){
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrlRatePlan}/rates/update`, payload, { headers: rootState.auth.headers });
          if (result.data.status == 200) {
              dispatch('global/setToastNotification', {type: 'success', title: i18n.t('lang.store.rates.rates'), text:i18n.t('lang.store.rates.ratesUpdateSuccess')}, {root: true});
              commit('setReloadData', true);
            } else {
              let errors = "";
              result.data.errors.forEach(element => {
                errors = errors + "<br>" + element;
              });
              dispatch('global/setToastNotification', {type: 'error', title: i18n.t('lang.store.rates.rates'), text:errors}, {root: true});
            }
        },
        async getRates({ commit, dispatch, rootState }, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlRatePlan){
            commit('setApiUrls');
          }
          commit('setRatesReady', false);
          commit('setLoadingState', true);
          commit('setCalendar', 'RESET');
          var rateSearch = {
            from:null,
            to:null
          };

          if (payload.calendar.startDate && payload.calendar.endDate ) {
            rateSearch.from = new Date(payload.calendar.startDate).toISOString().split('T')[0];
            rateSearch.to = new Date(payload.calendar.endDate).toISOString().split('T')[0];
          }else {
            let today = new Date();
            rateSearch.from = today.toISOString().split('T')[0];
            rateSearch.to = new Date(today.setDate(today.getDate() +  15 )).toISOString().split('T')[0];
          }
          commit('setSelectedHotel', payload.hotel);
          rateSearch.hotelId = state.selectedHotel;
          rateSearch.operatorIds = state.operators;
          await dispatch('getRatesPlan');
          await dispatch('getRoomTypes');
          commit('setRateSearch', rateSearch);
          const rateResults = await postRequestHandler(`${state.apiUrlRatePlan}/rates`, rateSearch, { headers: rootState.auth.headers });
          if (rateResults.data.status == 200) {
            dispatch('OrderRates', rateResults.data.data);
            let from = new Date(state.rateSearch.from);
            let to = new Date(state.rateSearch.to);
            let countDays = differenceInDays(to, from) + 1;
            if (countDays > 0) {
              for (let index = 1; index <= countDays; index++) {
                let  result = parseInt(format(new Date(from), "d")) + parseInt(index);
                commit('setCalendar', {
                  month: format(setDate(new Date(state.rateSearch.from), result), "LLL"),
                  week: format(setDate(new Date(state.rateSearch.from), result), "eee"),
                  day: format(setDate(new Date(state.rateSearch.from), result), "d"),
                  calendar: format(setDate(new Date(state.rateSearch.from), result), "yyyy-MM-dd")
                });
              }
            }
            commit('setRatesReady', true);
            commit('setRatesData', rateResults.data);
            commit('setLoadingState', false);
          } else {
            commit('setLoadingState', false);
            commit('setRatesReady', false);
            commit('setMessage', i18n.t('lang.store.rates.noResults'));
          }
        },
        getOperators({ commit, rootState }){
          commit('setOperators',rootState.auth.user.clients.operators);
        },
        async getRatesPlan({ commit, state, rootState }) {
          let search = {
            operatorIds: state.operators,
            hotelIds: [state.selectedHotel],
            pagination: {
              page: 1,
              per_page: 500
            },
            sort: {
              field: "hotel",
              order: "asc"
            }
          };
          const result = await postRequestHandler(`${state.apiUrlRatePlan}/rateplans`, search, { headers: rootState.auth.headers});
          if (result.status == 200) {
            commit('setRatesPlan', result.rateplans);
          } else {
            commit('setRatesPlan', 0);
          }
        },
        async getRoomTypes({ commit, state, rootState }) {
          let hotelIds = {
            hotelIds: [state.selectedHotel]
          };
          const result = await postRequestHandler(`${state.apiUrlRT}/hotels/roomtypes`, hotelIds, { headers: rootState.auth.headers});
          commit('setRoomTypes', result.roomtypes);
        },
        OrderRates({ commit }, payload) {
          let dates = [];
          payload.filter(data => {
            data.ratePlans.forEach(rateplans => {
              data = _.sortBy(rateplans.rates, function(o, index) {
                return o.date;
              });
              for (let prop in data) {
                dates.push(data[prop].date);
              }
            });
          });
          commit('setSortedRates', { first: dates[0], last: dates[parseInt(dates.length - 1)]});
        },
        RESET_RATES_MODULE({ commit }) {
          commit('RESET_RATES_MODULE');
        }
      };

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/rates.js